// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"44":"ff85ae79","148":"ff85ae79","176":"ff85ae79","328":"430cc607","684":"ff85ae79","820":"ff85ae79","884":"430cc607","952":"ff85ae79"}[chunkId] + ".chunk.css";
};